import React from 'react'

function Footer () {
  return (
    <>
      <footer className='footer'>
        <p className='footer-text'>Data provided by Marvel. © 2014 Marvel<br />developed by jito-jito ❤</p>
      </footer>
    </>
  )
}

export { Footer }
